import { PetitionProvider } from './../../providers/petition/petition';
import { WorkDaysProvider } from './../../providers/work-days/work-days';
import { PetitionTypes } from './../../models/petition-types';
import { AbsenceMotives } from './../../models/absence-motives';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController } from 'ionic-angular';
import { GlobalVars } from '../../app/app.environment';
import { globalDefines } from '../../app/app.constants';


@IonicPage()
@Component({
  selector: 'page-petition-absence',
  templateUrl: 'petition-absence.html',
})
export class PetitionAbsencePage {

  petition: any = {};

  public maxPeriod: number;
  public minPeriod: number;

  constructor(
    private loadingCtrl: LoadingController,
    public navCtrl: NavController, 
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public globalVars: GlobalVars,
    public petitionProvider: PetitionProvider,
    public workDaysProvider: WorkDaysProvider,
  ) {
    this.maxPeriod = this.globalVars.currentPeriod;
    this.minPeriod = this.globalVars.currentPeriod - 1;
  }

  
  calculateWorkDays() {
    if(this.petition.beginDate && this.petition.endDate && this.petition.beginDate <= this.petition.endDate) {
      
      this.workDaysProvider.getBusinessDatesCount(this.petition.beginDate, this.petition.endDate, this.petition.beginDateHalfDay, this.petition.endDateHalfDay)
      .then(workDays => {
        this.petition.workDays = workDays;
      })
    }

    else this.petition.workDays = null;
  }

  send() {
    if(this.checkData()) {
      this.petition.user = this.globalVars.user.name;
      this.petition.userKey = this.globalVars.user.key;
      this.petition.type = 'Ausencia';
      this.petition.typeId = PetitionTypes.absence;
      this.petition.comments = this.petition.comments ? this.petition.comments : ' ';
      this.petition.area = this.globalVars.user.area;
      this.petition.areaId = this.globalVars.user.areaId;
      this.petition.state = this.globalVars.user.areaId;
      this.petition.stateName = this.globalVars.user.area;
      this.petition.annulment = false;
      this.petition.annulmentSended = false;
      this.petition.creationDate = new Date().getTime();
      this.petition.mailbox = false;
      this.petition.motiveKey = Number(this.petition.motiveKey);
      this.petition.process = 'flow';
      
      if(this.petition.motiveKey == AbsenceMotives.APs) this.petition.workDays = this.petition.halfDay ? 0.5 : 1;
      
      switch(this.petition.motiveKey) {
        case AbsenceMotives.APs:      { this.petition.motive = 'Asuntos propios'; break; }
        case AbsenceMotives.holidays: { this.petition.motive = 'Vacaciones'; break; }
        case AbsenceMotives.medical:  { this.petition.motive = 'Médico'; break; }
      }

      console.log(this.petition)

      let loading = this.loadingCtrl.create();
      loading.present()

      this.petitionProvider.addPetition(this.petition)
      .then(msg => {
        loading.dismiss()
        this.showMessage(msg)
        this.navCtrl.pop();
      })
      
      .catch(error => {
        loading.dismiss()
        this.showMessage(error)
      })
    }

    else this.showMessage(`Introduzca todos los datos.`);
  }

  checkData() {
    if(this.petition.motiveKey == null) {
      return false;

      // Vacances
    } else if (this.petition.motiveKey == AbsenceMotives.holidays) {
      if(this.petition.beginDate && this.petition.endDate 
        && this.petition.period && this.petition.workDays) return true;

      // APs o metge
    } else if(this.petition.date) return true;
    
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/petition-absence/petition-absence.ts